<script setup lang="ts">
import { CustomerServiceProps } from "./CustomerService.props"

defineProps<CustomerServiceProps>()
</script>

<template>
  <div class="customer-service-wrapper">
    <p class="beaver-bold">
      {{ $t("services.customerService.contactUs") }}
    </p>

    <div class="flex flex-col gap-4 md:flex-row md:gap-8">
      <CardCustomerService
        v-for="card in cards"
        v-bind="card"
        class="md:max-w-[370px]"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">

.customer-service-wrapper {
  @apply bg-grey-main -mx-4 flex flex-col gap-4 p-4 py-6 md:mx-0 md:items-center md:rounded-lg md:py-10;
}

</style>
